var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "8" } },
            [
              _c("j-title-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { options: _vm.titleBasicInfo }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", [_vm._v("User Company ID")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: true,
                                      placeholder: "ID"
                                    },
                                    model: {
                                      value: _vm.user_company_id,
                                      callback: function($$v) {
                                        _vm.user_company_id = $$v
                                      },
                                      expression: "user_company_id"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", [_vm._v("User ID")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: true,
                                      placeholder: "ID"
                                    },
                                    model: {
                                      value: _vm.data_employee.id,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data_employee, "id", $$v)
                                      },
                                      expression: "data_employee.id"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_employee.first_name.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" First Name* ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "First Name"
                            },
                            model: {
                              value: _vm.$v.data_employee.first_name.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_employee.first_name,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_employee.first_name.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Place Of Birth ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Place Of Birth"
                            },
                            model: {
                              value: _vm.data_employee.place_of_birth,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "place_of_birth",
                                  $$v
                                )
                              },
                              expression: "data_employee.place_of_birth"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_employee.phone_number.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Phone Number* ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Phone Number",
                              type: "number"
                            },
                            model: {
                              value: _vm.$v.data_employee.phone_number.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_employee.phone_number,
                                  "$model",
                                  $$v
                                )
                              },
                              expression: "$v.data_employee.phone_number.$model"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "p__r--1", attrs: { md: "10" } },
                            [
                              _c("label", [_vm._v(" Active ")]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "label-info-user-active" },
                                [
                                  _vm._v(
                                    "\n                An active user can access Officeless App & Studio.\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  staticClass: "label-more-info-user-active",
                                  attrs: {
                                    to:
                                      "/administrator/company/settings/security"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                More Info\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "2" } },
                            [
                              _c("j-toggle", {
                                attrs: { disabled: _vm.isAdmin },
                                model: {
                                  value: _vm.data_employee.employee_status,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_employee,
                                      "employee_status",
                                      $$v
                                    )
                                  },
                                  expression: "data_employee.employee_status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Email")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Personal Email",
                              disabled: ""
                            },
                            model: {
                              value: _vm.data_employee.email,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "email", $$v)
                              },
                              expression: "data_employee.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Last Name ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Last Name"
                            },
                            model: {
                              value: _vm.data_employee.last_name,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "last_name", $$v)
                              },
                              expression: "data_employee.last_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { sm: "12", md: "8" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.data_employee.date_of_birth.$error
                                  }
                                },
                                [
                                  _c("label", [_vm._v(" Date Of Birth* ")]),
                                  _vm._v(" "),
                                  _c("j-datepicker", {
                                    attrs: {
                                      "disabled-dates": _vm.birthday_dates,
                                      "error-required":
                                        _vm.$v.data_employee.date_of_birth
                                          .$error,
                                      format: "MMM dd, yyyy",
                                      "error-message":
                                        "Age must be greater or equal to 18",
                                      placeholder: "Jan 01, 2020"
                                    },
                                    model: {
                                      value: _vm.data_employee.date_of_birth,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.data_employee,
                                          "date_of_birth",
                                          $$v
                                        )
                                      },
                                      expression: "data_employee.date_of_birth"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "12", md: "4" } },
                            [
                              _c(
                                "b-form-group",
                                [
                                  _c("label", [_vm._v(" Age ")]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      "error-message": "err",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.data_employee.age,
                                      callback: function($$v) {
                                        _vm.$set(_vm.data_employee, "age", $$v)
                                      },
                                      expression: "data_employee.age"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.load_first,
                              expression: "load_first"
                            }
                          ],
                          class: {
                            "error-input": _vm.$v.data_employee.role.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Role* ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.roles_option,
                              disabled: _vm.isAdmin,
                              "value-format": "object",
                              placeholder: "Select Role",
                              label: "name"
                            },
                            model: {
                              value: _vm.data_employee.role,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "role", $$v)
                              },
                              expression: "data_employee.role"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ],
                          class: {
                            "error-input": _vm.$v.data_employee.password.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" New Password ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Password",
                              "error-message": "Password minimum is 5 character"
                            },
                            model: {
                              value: _vm.data_employee.password,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "password", $$v)
                              },
                              expression: "data_employee.password"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "j-checkbox",
                            {
                              staticClass: "float-to-right",
                              model: {
                                value: _vm.show_pass,
                                callback: function($$v) {
                                  _vm.show_pass = $$v
                                },
                                expression: "show_pass"
                              }
                            },
                            [_vm._v("show password")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ]
                        },
                        [
                          _c("label", [_vm._v(" Employee Code ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Employee Code"
                            },
                            model: {
                              value: _vm.data_employee.code,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "code", $$v)
                              },
                              expression: "data_employee.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { sm: "12", md: "4" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("j-title-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { options: _vm.titleAccountProfile }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ]
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("ID Type")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.id_type_options,
                              label: "name",
                              "value-format": "object",
                              placeholder: "Select ID Type"
                            },
                            model: {
                              value: _vm.data_employee.id_type,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "id_type", $$v)
                              },
                              expression: "data_employee.id_type"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Religion")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.religion_options,
                              label: "name",
                              placeholder: "Select Religion"
                            },
                            model: {
                              value: _vm.data_employee.religion,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "religion", $$v)
                              },
                              expression: "data_employee.religion"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Nationality")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.nationality_options,
                              label: "name",
                              placeholder: "Select Nationality"
                            },
                            model: {
                              value: _vm.data_employee.nationality_type,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "nationality_type",
                                  $$v
                                )
                              },
                              expression: "data_employee.nationality_type"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Home Address")]),
                          _vm._v(" "),
                          _c("j-textarea", {
                            attrs: { placeholder: "Home Address" },
                            model: {
                              value: _vm.data_employee.address,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "address", $$v)
                              },
                              expression: "data_employee.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: false,
                              expression: "false"
                            }
                          ]
                        },
                        [
                          _c("label", [_vm._v("Marital Status")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.marital_options,
                              label: "name",
                              placeholder: "Select Marital Status"
                            },
                            model: {
                              value: _vm.data_employee.marital_status,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "marital_status",
                                  $$v
                                )
                              },
                              expression: "data_employee.marital_status"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Postal Code")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: { placeholder: "Postal Code" },
                            model: {
                              value: _vm.data_employee.postal_code,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "postal_code", $$v)
                              },
                              expression: "data_employee.postal_code"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Country of Home Address")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_country,
                              placeholder: "Select Country",
                              "value-format": "object",
                              label: "name"
                            },
                            on: { select: _vm.resetProvince },
                            model: {
                              value: _vm.data_employee.country,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "country", $$v)
                              },
                              expression: "data_employee.country"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.data_employee.country &&
                                _vm.data_employee.country.id,
                              expression:
                                "data_employee.country && data_employee.country.id"
                            }
                          ]
                        },
                        [
                          _c("label", [_vm._v("Province of Home Address")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.home_province_options,
                              placeholder: "Select Province",
                              label: "name"
                            },
                            on: { select: _vm.resetCity },
                            model: {
                              value: _vm.data_employee.province,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "province", $$v)
                              },
                              expression: "data_employee.province"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.data_employee.province,
                              expression: "data_employee.province"
                            }
                          ]
                        },
                        [
                          _c("label", [_vm._v("City of Home Address")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.home_city_options,
                              placeholder: "Select City",
                              label: "name"
                            },
                            model: {
                              value: _vm.data_employee.city,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "city", $$v)
                              },
                              expression: "data_employee.city"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v("Notes")]),
                          _vm._v(" "),
                          _c("j-textarea", {
                            attrs: { placeholder: "Employee Notes" },
                            model: {
                              value: _vm.data_employee.notes,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "notes", $$v)
                              },
                              expression: "data_employee.notes"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("j-title-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { options: _vm.titleSettings }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ]
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Secretary Mode ")]),
                          _vm._v(" "),
                          _c("j-toggle", {
                            model: {
                              value: _vm.data_employee.secretary_mode,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "secretary_mode",
                                  $$v
                                )
                              },
                              expression: "data_employee.secretary_mode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [
                            _vm._v(" Secretary Mode Mapping Team ")
                          ]),
                          _vm._v(" "),
                          _c("j-multi-select", {
                            attrs: {
                              options: _vm.list_teams,
                              label: "name",
                              "value-format": "object",
                              placeholder: "Select Secretary Mode Mapping Team"
                            },
                            model: {
                              value: _vm.data_employee.secretary_mode_mapping,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "secretary_mode_mapping",
                                  $$v
                                )
                              },
                              expression: "data_employee.secretary_mode_mapping"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Employee ID ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Employee ID"
                            },
                            model: {
                              value: _vm.data_employee.employee_id,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "employee_id", $$v)
                              },
                              expression: "data_employee.employee_id"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("j-title-header", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: false,
                    expression: "false"
                  }
                ],
                attrs: { options: _vm.titlePaymentInfo }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ]
                },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", md: "12" } },
                    [
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Bank Name ")]),
                          _vm._v(" "),
                          _c("j-single-select", {
                            attrs: {
                              options: _vm.list_bank,
                              placeholder: "Select Bank Name",
                              "value-format": "object",
                              label: "name"
                            },
                            model: {
                              value: _vm.data_employee.bank_name,
                              callback: function($$v) {
                                _vm.$set(_vm.data_employee, "bank_name", $$v)
                              },
                              expression: "data_employee.bank_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Bank Account Number ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Bank Account Number"
                            },
                            model: {
                              value: _vm.data_employee.bank_account_number,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "bank_account_number",
                                  $$v
                                )
                              },
                              expression: "data_employee.bank_account_number"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Bank Account Holder Name ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Bank Account Name"
                            },
                            model: {
                              value: _vm.data_employee.bank_account_holder_name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "bank_account_holder_name",
                                  $$v
                                )
                              },
                              expression:
                                "data_employee.bank_account_holder_name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c("label", [_vm._v(" Bank Account Branch ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "max-length": 50,
                              placeholder: "Bank Account Name"
                            },
                            model: {
                              value: _vm.data_employee.bank_account_branch,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_employee,
                                  "bank_account_branch",
                                  $$v
                                )
                              },
                              expression: "data_employee.bank_account_branch"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", md: "3" } },
            [
              _c(
                "b-form-group",
                [
                  _c("label", [_vm._v(" Photo Profile ")]),
                  _vm._v(" "),
                  _c("j-photo-uploader", {
                    ref: "multi",
                    attrs: {
                      "api-token": _vm.api,
                      "img-default": _vm.image_default,
                      "url-upload": _vm.url_upload,
                      label: !_vm.image_default
                        ? "Upload Photo"
                        : "Change Photo"
                    },
                    on: { url: _vm.getDataImage }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da64560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da64560","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/detail/jEmployeeFormUpdate.vue
// module id = null
// module chunks = 